import React from 'react';
import { Widget } from './index';
import {Button, Col, Divider, message, Table, Tooltip, } from "antd";
import Card from "antd/es/card";
import * as AntdIcons from "@ant-design/icons";
import { useHistory } from "react-router-dom";


import {transformColumn} from "../../utils/TransformActionTable";
import Icon from "../../components/util-components/Icon";




export class WidgetTable extends Widget {

  constructor(obj={}){
    super(obj);

    this.headers = obj.headers;
    this.rows = obj.rows;
    // this.id = uuid();
  }

  getComponent() {
    const history = useHistory();
    return () => {

      const transformDataSource = (rows=this.rows) => {
        return rows
      }

      const handleButtonClick = () => {
        history.push(this.link.url);
      }


      return (
        <Card 
        title={this.title} 
        extra={this.link ?
          <Button 
            type="primary" 
            size="small" 
            icon={this.link.icono ? <Icon type={AntdIcons[this.link.icono]}/> : null} 
            onClick={handleButtonClick}>
            {this.link.text}
          </Button>
        : null}>
          <Table
            // id={this.id}
            className={this.alternateColor ? 'alternate-rows' : ''}
            columns={transformColumn(this.headers)}
            dataSource={transformDataSource()}
            scroll={{ y: this.scrollY, x: 1 }}
            pagination={this.pagination}
            bordered={this.bordered}
            size={this.tableSize}
          />
          {/*{this.copy && <CopyToolbar id={this.id}/>}*/}
        </Card>
      );
    }
  }

  transformToWidget = (data) => {
    const customOptions = data.customOptions ?? {};

    this.title = data.title;
    this.type = data.type;
    this.size = data.size;
    this.value = data.value;
    this.headers = customOptions.header ?? data.header;
    this.rows = data.rows;
    this.copy = data.copy ?? false
    this.link = data.link ?? null

    this.tableSize = customOptions.tableSize ?? data.table_size ?? "middle";
    this.scrollY = customOptions.scrollY ?? data.scrollY;
    this.bordered = customOptions.bordered ?? data.bordered ?? false;
    this.alternateColor = customOptions.alternateColor ?? data.alternateColor ?? false;

    const pagination = customOptions.pagination ?? data.pagination;
    this.pagination = pagination === false
      ? false
      : { hideOnSinglePage: true, defaultPageSize: 10, ...pagination };
    return this;
  }

}